module.exports = __webpack_public_path__ + "static/media/login@2x.92bd07b0.jpg";